var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_9533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0519 10.0001H18.5519M18.5519 10.0001L15.7744 6.66673M18.5519 10.0001L15.7744 13.3334M11.8853 5.83339V4.31173C11.8852 4.0812 11.8374 3.85319 11.7448 3.6421C11.6522 3.43101 11.5167 3.24142 11.3471 3.08534C11.1775 2.92925 10.9773 2.81005 10.7592 2.73527C10.5412 2.66049 10.31 2.63176 10.0803 2.65089L3.41359 3.20589C2.99696 3.24059 2.6086 3.4306 2.3255 3.73823C2.04241 4.04587 1.88527 4.44866 1.88525 4.86673V15.1334C1.88527 15.5515 2.04241 15.9543 2.3255 16.2619C2.6086 16.5695 2.99696 16.7595 3.41359 16.7942L10.0803 17.3501C10.31 17.3692 10.5413 17.3404 10.7594 17.2656C10.9775 17.1908 11.1778 17.0715 11.3474 16.9153C11.5171 16.7592 11.6525 16.5695 11.745 16.3583C11.8376 16.1471 11.8854 15.919 11.8853 15.6884V14.1667",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_9533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.21875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.9df0d394913987c1a3a7918637e5b558.svg";
export { ForwardRef as ReactComponent };